import { writable } from 'svelte/store';
import { fetchPublicDataTables, type ApiTable } from './data-tables-api';

export const customTablesStore = writable<ApiTable[]>([]);
/** Мета built-in таблиць (slug → {name, icon, color}) з урахуванням override-ів. */
export const builtInTablesStore = writable<Record<string, ApiTable>>({});

let fetched = false;
let fetchPromise: Promise<void> | null = null;

/** Завантажити кастомні таблиці один раз. Повторні виклики повертають кешовані дані. */
export async function loadCustomTables(): Promise<void> {
  if (fetched) return;
  if (fetchPromise) return fetchPromise;
  fetchPromise = (async () => {
    try {
      const r = await fetchPublicDataTables();
      customTablesStore.set(r.items.filter((t) => !t.builtIn));
      const builtIn: Record<string, ApiTable> = {};
      for (const t of r.items) if (t.builtIn) builtIn[t.slug] = t;
      builtInTablesStore.set(builtIn);
      fetched = true;
    } catch {
      // retry on next mount
    } finally {
      fetchPromise = null;
    }
  })();
  return fetchPromise;
}

/** Примусово скинути кеш (наприклад після додавання/видалення таблиці). */
export function invalidateCustomTables(): void {
  fetched = false;
  loadCustomTables();
}
